import styled from "styled-components";


export const TermsCardsSection = styled.section`

& h2{
	font-weight: 500;
}

.terms-cards__container{
	margin-top: 3.75rem;
	gap: 1.875rem;
}
`
export const DemandedSection = styled.section`

.demanded-cards__container{
	margin-top: 3.75rem;
	flex-wrap: wrap;
	gap: 2.5rem;
	& div {
		width: 31%;
		height: 17.5rem;

		& iframe {
			width: 100%;
			height: 100%;
		}
	}
}
`

export const PopularAssetsSection = styled.section`

& p {
	margin-top: 1.25rem;
}

.widget{
	margin-top: 3.75rem;
	width: 100%;
	height: 37.5rem;
	& iframe{
		width: 100%;
		height: 100%;
	}
}
`